// extracted by mini-css-extract-plugin
export default {"inset":"ZgNSHfl_M1kvt2IfYO6g","hoverInset":"RTuLrioTIH4pwPdJljZ1","selectedInset":"rzTlYjtUaUBSoC5mPmoq","icon":"mDcarVsbL1SY5QTq0v4g"};